export default {
  API_ENDPOINT: 'https://quiet-cove-54792.herokuapp.com',
  TOKEN_KEY: 'city-client-auth-token',
}
